<template>
  <div id="award-bidding-dashboard" class="professional-lom-details">
    <div class="lom-details-card">
      <!-- Top Right Actions -->
      <div class="top-actions">
        <v-btn icon class="top-action-btn" @click="refreshPageData" title="Refresh Data">
          <v-icon size="20">mdi-refresh</v-icon>
        </v-btn>
        <v-btn icon class="top-action-btn close-btn" @click="closePrompt">
          <v-icon size="20">mdi-close</v-icon>
        </v-btn>
      </div>

      <!-- Professional Header -->
      <v-app-bar class="professional-header" flat>
        <div class="header-content">
          <div class="header-left">
            <div class="icon-section">
              <v-icon size="28" color="white">mdi-office-building</v-icon>
            </div>
            <div class="title-section">
              <h2 class="modal-title">LO Details</h2>
              <p class="modal-subtitle">
                Complete local organization information
              </p>
            </div>
          </div>
          <div class="header-actions">
          </div>
        </div>
      </v-app-bar>
      <!-- Professional Content Area -->
      <div class="professional-content pa-0">
        <div class="content-container">
          <!-- Loading Indicator -->
          <div class="loading-section" v-if="LoadingFlag">
            <v-progress-circular indeterminate color="primary" size="42" width="4" class="mr-3"></v-progress-circular>
            <span class="loading-text">Loading data...</span>
          </div>

          <!-- No Records Message -->
          <div class="empty-section" v-if="!ResultFlag && !LoadingFlag">
            <v-icon size="48" color="#f8a51c" class="mb-3">mdi-alert-circle-outline</v-icon>
            <h3 class="empty-title">No Records Found</h3>
            <p class="empty-description">
              There are no LO details available at this time.
            </p>
          </div>

          <!-- Coming Soon Message -->
          <div class="empty-section" v-if="ComingSoonFlag && !LoadingFlag">
            <v-icon size="48" color="#1976d2" class="mb-3">mdi-clock-outline</v-icon>
            <h3 class="empty-title">Coming Soon</h3>
            <p class="empty-description">
              This feature will be available in the near future.
            </p>
          </div>

          <!-- Main Content Section when data is available -->
          <div class="main-content-section" v-if="ResultFlag && !ComingSoonFlag">
            <div class="content-grid">
              <!-- LO Location Card -->
              <div class="content-card location-card">
                <div class="card-header">
                  <v-icon size="24" color="white" class="mr-2">mdi-map-marker</v-icon>
                  <h3 class="card-title">LO Location</h3>
                </div>
                <div class="card-body">
                  <v-form ref="form1" v-model="valid1" lazy-validation v-on:submit.prevent="confirmAlert">
                    <div class="form-grid">
                      <div class="form-group">
                        <label class="form-label">State</label>
                        <v-autocomplete :reduce="(option) => option.value" :loading="StateCodeOptionsLoading"
                          :items="StateCodeOptions" :rules="StateCodeRules" v-model="StateCode" clearable required dense
                          outlined hide-details="auto" prepend-inner-icon="mdi-map"
                          class="form-control"></v-autocomplete>
                      </div>
                      <div class="form-group">
                        <label class="form-label">District</label>
                        <v-autocomplete :reduce="(option) => option.value" :loading="DistrictCodeOptionsLoading"
                          :items="DistrictCodeOptions" :rules="DistrictCodeRules" v-model="DistrictCode" clearable
                          required outlined dense hide-details="auto" prepend-inner-icon="mdi-map-marker-radius"
                          class="form-control"></v-autocomplete>
                      </div>
                      <div class="form-group">
                        <label class="form-label">City</label>
                        <v-autocomplete :reduce="(option) => option.value" :loading="CityCodeOptionsLoading"
                          :items="CityCodeOptions" :rules="CityCodeRules" v-model="CityCode" clearable required outlined
                          dense hide-details="auto" prepend-inner-icon="mdi-city" class="form-control"></v-autocomplete>
                      </div>
                    </div>
                    <div class="form-actions">
                      <v-btn @click="confirmAlert" color="#1976d2" rounded elevation="2" class="save-btn"
                        :loading="SubmitFlag">
                        <v-icon left>mdi-content-save</v-icon>
                        Save
                      </v-btn>
                    </div>
                  </v-form>
                </div>
              </div>

              <!-- Extension LO Card -->
              <div class="content-card extension-card">
                <div class="card-header">
                  <v-icon size="24" color="white" class="mr-2">mdi-office-building-outline</v-icon>
                  <h3 class="card-title">Extension LO</h3>
                  <div class="card-badge">
                    <span class="badge-text">Total: {{ row.LomsCount }}</span>
                  </div>
                </div>
                <div class="card-body">
                  <div class="items-list">
                    <div class="list-item" v-for="(item, index) in row.Loms" :key="index">
                      <div class="item-index">{{ index + 1 }}</div>
                      <div class="item-content">{{ item }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Growth Data Card -->
              <div class="content-card growth-card">
                <div class="card-header">
                  <v-icon size="24" color="white" class="mr-2">mdi-chart-timeline-variant</v-icon>
                  <h3 class="card-title">{{ tableOptions3.TableTitle }}</h3>
                </div>
                <div class="card-body">
                  <div class="empty-message" v-if="tableData3.length == 0">
                    <v-icon color="#f8a51c" size="20" class="mr-2">mdi-alert-circle-outline</v-icon>
                    <span>No records found</span>
                  </div>
                  <div class="data-table-container" v-if="tableData3.length > 0">
                    <v-data-table class="professional-table" loading-text="Loading... Please wait" v-model="selected3"
                      :search="search3" :loading="tableLoadingFlag3" :headers="tableColumns3" :items="tableData3"
                      :show-select="tableOptions3.ShowSelectFlag" :item-key="tableOptions3.ItemKey"
                      :single-select="tableOptions3.SingleSelectFlag" :items-per-page="tableOptions3.ItemsPerPage"
                      :footer-props="tableOptions3.FooterProps">
                      <template #[`item.Growth`]="{ item }">
                        <v-chip :color="item.Color" small>
                          <span class="white--text font-weight-medium">
                            {{ item.Growth }}
                          </span>
                        </v-chip>
                      </template>
                    </v-data-table>
                  </div>
                </div>
              </div>

              <!-- Foundation Contribution Card -->
              <div class="content-card foundation-card">
                <div class="card-header">
                  <v-icon size="24" color="white" class="mr-2">mdi-currency-usd</v-icon>
                  <h3 class="card-title">Foundation Contribution</h3>
                  <div class="card-badge">
                    <span class="badge-text">Amount: {{ row.FoundationAmount }}</span>
                  </div>
                </div>
                <div class="card-body">
                  <div class="empty-message" v-if="tableData1.length == 0">
                    <v-icon color="#f8a51c" size="20" class="mr-2">mdi-alert-circle-outline</v-icon>
                    <span>No records found</span>
                  </div>
                  <div class="data-table-container" v-if="tableData1.length > 0">
                    <v-data-table class="professional-table" loading-text="Loading... Please wait" v-model="selected1"
                      :search="search1" :loading="tableLoadingFlag1" :headers="tableColumns1" :items="tableData1"
                      :show-select="tableOptions1.ShowSelectFlag" :item-key="tableOptions1.ItemKey"
                      :single-select="tableOptions1.SingleSelectFlag" :items-per-page="tableOptions1.ItemsPerPage"
                      :footer-props="tableOptions1.FooterProps">
                    </v-data-table>
                  </div>
                </div>
              </div>
            </div>
            <!-- End of content-grid -->
          </div>
          <!-- End of main-content-section -->

          <!-- Professional Action Section -->
          <div class="action-section" v-if="!LoadingFlag">
            <div class="action-wrapper">
              <v-btn color="#6c757d" elevation="2" rounded large class="action-btn close-btn" @click="closePrompt">
                <v-icon left>mdi-close-circle</v-icon>
                Close
              </v-btn>
            </div>
          </div>
        </div>
        <!-- End of content-container -->
      </div>
    </div>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    LomCode: {
      type: Number,
    },
  },
  data() {
    return {
      valid1: true,
      search: "",
      ProgessStart: 0,
      uploadPercentage: 0,

      alert: {},

      valid: true,

      SubmitFlag: false,
      RecordFlag: false,
      ResultFlag: false,
      LoadingFlag: false,
      ComingSoonFlag: false,

      records: {},
      row: {},

      StateCodeRules: [(v) => !!v || "State is required"],
      StateCode: "",
      StateCodeOptions: [],
      StateCodeOptionsLoading: false,

      DistrictCodeRules: [(v) => !!v || "District is required"],
      DistrictCode: "",
      DistrictCodeOptions: [],
      DistrictCodeOptionsLoading: false,

      CityCodeRules: [(v) => !!v || "City is required"],
      CityCode: "",
      CityCodeOptions: [],
      CityCodeOptionsLoading: false,

      tableOptions1: [],
      tableColumns1: [],
      tableData1: [],

      tableOptions3: [],
      tableColumns3: [],
      tableData3: [],

      tableLoadingFlag1: false,
      selected1: [],
      search1: "",

      tableLoadingFlag3: false,
      selected3: [],
      search3: "",

      RoleId: 0,
      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
      FloatingButtonOptions: {},
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      var n1 = Object.keys(tr).length;
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        if (!flag) {
          this.$router.push("/access-denied");
        }
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;
        this.FloatingButtonOptions = tr.FloatingButtonOptions;
        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        this.CurrentYearId = CurrentJciYearId;
        var YearName = parseInt(tr.CurrentJciYearName);
        this.YearName = YearName;
      }
    },
    records: function () {
      this.getStateCodeOptions();
      this.StateCode = this.records.StateId;
      this.DistrictCode = this.records.DistrictId;
      this.CityCode = this.records.CityId;
    },
    StateCodeOptions: function () {
      this.StateCodeOptionsLoading = false;
    },
    DistrictCodeOptions: function () {
      this.DistrictCodeOptionsLoading = false;
    },
    CityCodeOptions: function () {
      this.CityCodeOptionsLoading = false;
    },
    StateCode: function () {
      this.DistrictCodeOptions = [];
      this.CityCodeOptions = [];
      this.getDistrictCodeOptions();
    },
    DistrictCode: function () {
      this.CityCodeOptions = [];
      this.getCityCodeOptions();
    },
    LomCode: function () {
      this.tableOptions1 = [];
      this.tableColumns1 = [];
      this.tableData1 = [];
      this.getTableRecords();
      this.getLomLocationDetails();
    },
  },
  methods: {
    refreshPageData() {
      this.pageData();
    },
    pageData() {
      this.resetForm();
      this.getTableRecords();
      this.getLomLocationDetails();
    },
    closePrompt() {
      this.$emit("hideLomDetailsPrompt");
    },
    resetForm() {
      this.CityCode = "";
      this.CityCodeOptions = [];

      this.DistrictCode = "";
      this.DistrictCodeOptions = [];

      this.StateCode = "";
      this.StateCodeOptions = [];
    },
    getStateCodeOptions() {
      this.StateCodeOptionsLoading = true;
      var selectbox1_source = "StateCode";
      var selectbox1_destination = "StateCodeOptions";
      var selectbox1_url = "api/states/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getDistrictCodeOptions() {
      var StateCode = this.StateCode;
      if (StateCode != "") {
        this.DistrictCodeOptionsLoading = true;
        var selectbox1_source = "DistrictCode";
        var selectbox1_destination = "DistrictCodeOptions";
        var selectbox1_url = "api/district/options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
          StatesCode: StateCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    getCityCodeOptions() {
      var DistrictCode = this.DistrictCode;
      if (DistrictCode != "") {
        this.CityCodeOptionsLoading = true;
        var selectbox1_source = "CityCode";
        var selectbox1_destination = "CityCodeOptions";
        var selectbox1_url = "api/city/options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          DistrictCode: DistrictCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    getTableRecords() {
      var validate1 = true;
      if (validate1) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/lom/year-data";
        var role = this.RoleId;
        if (role == 2) {
          var upload = {
            UserInterface: 3,
            Lom: this.LomCode,
          };
        } else {
          var upload = {
            UserInterface: 3,
          };
        }

        const thisIns = this;
        var records = "";
        var flag = 0;

        this.row = {};
        this.ResultFlag = false;
        this.LoadingFlag = true;
        this.ComingSoonFlag = false;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            thisIns.LoadingFlag = false;
            flag = response.data.flag;
            records = response.data.records;
            thisIns.ResultFlag = flag;
            thisIns.ComingSoonFlag = records.ComingSoonFlag;

            if (flag == 1) {
              thisIns.row = records;

              thisIns.tableOptions1 = records.TableOptions1;
              thisIns.tableColumns1 = records.TableHeader1;
              thisIns.tableData1 = records.TableData1;

              thisIns.tableOptions3 = records.TableOptions3;
              thisIns.tableColumns3 = records.TableHeader3;
              thisIns.tableData3 = records.TableData3;
            }
          })
          .catch(function (error) {
            thisIns.toast("error", error);
            thisIns.LoadingFlag = false;
            thisIns.tableLoadingFlag1 = false;
            thisIns.tableLoadingFlag3 = false;
          });
      }
    },
    getLomLocationDetails() {
      var validate1 = true;
      if (validate1) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/lom/show";
        if (this.RoleId == 2) {
          var upload = {
            UserInterface: 1,
            Lom: this.LomCode,
          };
        } else {
          var upload = {
            UserInterface: 2,
          };
        }

        this.RecordFlag = false;

        const thisIns = this;
        var records = "";
        var flag = 0;

        this.LoadingFlag = true;
        this.records = {};

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            thisIns.LoadingFlag = false;
            flag = response.data.flag;
            records = response.data.records;
            thisIns.RecordFlag = flag;

            if (flag == 1) {
              if (records.StateId != "") {
                thisIns.records = records;
              }
            }
          })
          .catch(function (error) {
            thisIns.toast("error", error);
            thisIns.LoadingFlag = false;
          });
      }
    },
    confirmAlert() {
      if (this.StateCode > 0 && this.DistrictCode > 0 && this.CityCode > 0) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Save`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          if (result.isConfirmed) {
            this.submitForm();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        this.sweetAlert("error", "Kindly fill the required fields", true);
      }
    },
    submitForm() {
      this.ResultFlag = false;

      var upload = {
        UserInterface: 2,
        City: this.CityCode,
      };

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;

      var add_url = server_url + "api/lom/update";

      const thisIns = this;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          var output = response.data.output;
          var flag = response.data.flag;

          if (flag == 1) {
            thisIns.sweetAlert("success", output, true);
            thisIns.pageData();
          } else {
            thisIns.sweetAlert("error", output, false);
          }
        })
        .catch(function (error) {
          // handle error
        });
    },
  },
  beforeMount() {
    var RoleId = this.$session.get("RoleId");
    RoleId = RoleId == (null || undefined) ? "" : RoleId;
    this.RoleId = RoleId;

    this.refreshPageData();
  },
};
</script>

<style lang="scss">
.professional-lom-details {
  .lom-details-card {
    width: 100%;
    background: #ffffff;
    position: relative;

    // Top Right Actions
    .top-actions {
      position: absolute;
      top: 12px;
      right: 12px;
      z-index: 10;
      display: flex;
      gap: 10px;

      .top-action-btn {
        background: rgba(255, 255, 255, 0.2) !important;
        backdrop-filter: blur(4px);
        border: 1px solid rgba(255, 255, 255, 0.3);
        transition: all 0.3s ease;
        height: 36px;
        width: 36px;
        color: white !important;

        &:hover {
          background: rgba(255, 255, 255, 0.3) !important;
          transform: scale(1.1);
          box-shadow: 0 0 15px rgba(255, 255, 255, 0.2);
        }

        &.close-btn:hover {
          transform: rotate(90deg) scale(1.1);
        }

        .v-icon {
          color: white;
        }
      }
    }

    // Professional Header Styles
    .professional-header {
      background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
      color: white;
      border-radius: 0 !important;
      position: relative;
      overflow: hidden;

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E") repeat;
        opacity: 0.1;
      }

      .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 2rem;
        position: relative;
        z-index: 1;

        .header-left {
          display: flex;
          align-items: center;
          flex: 1;

          .icon-section {
            background: rgba(255, 255, 255, 0.2);
            border-radius: 50%;
            width: 56px;
            height: 56px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 1.5rem;
            backdrop-filter: blur(10px);
            border: 2px solid rgba(255, 255, 255, 0.3);
          }

          .title-section {
            .modal-title {
              font-size: 1.75rem;
              font-weight: 700;
              margin: 0 0 0.25rem 0;
              color: white;
              font-family: "Roboto", sans-serif;
              line-height: 1.2;
              text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            }

            .modal-subtitle {
              font-size: 1rem;
              color: rgba(255, 255, 255, 0.9);
              margin: 0;
              font-weight: 400;
              opacity: 0.95;
            }
          }
        }

        .header-actions {
          .action-icon-btn {
            background: rgba(255, 255, 255, 0.2) !important;
            backdrop-filter: blur(10px);
            border: 2px solid rgba(255, 255, 255, 0.3);
            transition: all 0.3s ease;
            height: 40px;
            width: 40px;

            &:hover {
              background: rgba(255, 255, 255, 0.3) !important;
              transform: rotate(90deg);
            }

            .v-icon {
              color: white;
            }
          }
        }
      }
    }

    // Professional Content Styles
    .professional-content {
      .content-container {
        padding: 0;

        // Loading Section
        .loading-section {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 3rem;

          .loading-text {
            font-size: 1.1rem;
            color: #64748b;
            font-weight: 500;
          }
        }

        // Empty Section (No Records, Coming Soon)
        .empty-section {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 3rem;
          text-align: center;

          .empty-title {
            font-size: 1.5rem;
            font-weight: 600;
            color: #334155;
            margin: 0 0 0.5rem 0;
          }

          .empty-description {
            font-size: 1.1rem;
            color: #64748b;
            max-width: 400px;
          }
        }

        // Main Content Section
        .main-content-section {
          padding: 1.5rem;

          .content-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 1.5rem;
            margin-bottom: 1.5rem;

            @media (max-width: 960px) {
              grid-template-columns: 1fr;
            }

            // Card Styles
            .content-card {
              background: white;
              border-radius: 12px;
              overflow: hidden;
              box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
              height: 100%;
              display: flex;
              flex-direction: column;

              .card-header {
                background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
                color: white;
                padding: 1.25rem;
                display: flex;
                align-items: center;
                position: relative;

                &::before {
                  content: "";
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E") repeat;
                  opacity: 0.1;
                }

                .card-title {
                  font-size: 1.25rem;
                  font-weight: 600;
                  margin: 0;
                  position: relative;
                  z-index: 2;
                }

                .card-badge {
                  margin-left: auto;
                  background: rgba(255, 255, 255, 0.2);
                  padding: 0.35rem 0.75rem;
                  border-radius: 16px;
                  font-weight: 500;
                  font-size: 0.875rem;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  backdrop-filter: blur(10px);
                  border: 1px solid rgba(255, 255, 255, 0.3);
                  position: relative;
                  z-index: 2;
                }
              }

              .card-body {
                padding: 1.5rem;
                flex: 1;

                // Form Styles
                .form-grid {
                  display: grid;
                  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                  gap: 1.25rem;
                  margin-bottom: 1.5rem;

                  .form-group {
                    .form-label {
                      display: block;
                      font-size: 0.9375rem;
                      font-weight: 500;
                      color: #334155;
                      margin-bottom: 0.5rem;
                    }

                    .form-control {
                      width: 100%;

                      &.v-input {
                        margin-top: 0;
                      }
                    }
                  }
                }

                .form-actions {
                  display: flex;
                  justify-content: center;
                  margin-top: 1.5rem;

                  .save-btn {
                    min-width: 120px;
                    font-weight: 600;
                    color: white;
                    text-transform: none;
                    letter-spacing: 0.5px;
                    background: linear-gradient(135deg,
                        #1976d2 0%,
                        #1565c0 100%);
                    box-shadow: 0 4px 15px rgba(25, 118, 210, 0.3);

                    &:hover {
                      transform: translateY(-2px);
                      box-shadow: 0 6px 20px rgba(25, 118, 210, 0.4);
                    }
                  }
                }

                // List Item Styles
                .items-list {
                  .list-item {
                    display: flex;
                    align-items: flex-start;
                    padding: 0.75rem 0;
                    border-bottom: 1px solid #f1f5f9;

                    &:last-child {
                      border-bottom: none;
                    }

                    .item-index {
                      width: 28px;
                      height: 28px;
                      background: #1976d2;
                      color: white;
                      border-radius: 50%;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      font-weight: 600;
                      font-size: 0.875rem;
                      margin-right: 0.75rem;
                      flex-shrink: 0;
                    }

                    .item-content {
                      flex: 1;
                      line-height: 1.5;
                      font-size: 0.9375rem;
                      color: #334155;
                      padding-top: 0.25rem;
                    }
                  }
                }

                // Empty Message
                .empty-message {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  padding: 1.5rem;
                  background: #fff9ec;
                  border-radius: 8px;
                  color: #92400e;
                  font-weight: 500;
                }

                // Data Table Styles
                .data-table-container {
                  .professional-table {
                    border-radius: 8px;
                    overflow: hidden;
                    box-shadow: none;
                    border: 1px solid #e2e8f0;

                    .v-data-table__wrapper {
                      border-radius: 8px;
                    }

                    .v-data-table-header {
                      background: #f8fafc;

                      th {
                        font-weight: 600;
                        color: #334155;
                        font-size: 0.875rem;
                        text-transform: none;
                        letter-spacing: 0;
                      }
                    }

                    .v-data-table__empty-wrapper {
                      color: #64748b;
                    }

                    .v-chip {
                      font-weight: 600;
                      font-size: 0.8125rem;
                    }
                  }
                }
              }
            }
          }
        }

        // Action Section
        .action-section {
          padding: 1.5rem;
          background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
          border-top: 1px solid #e9ecef;
          border-radius: 0 0 16px 16px;

          .action-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;

            .action-btn {
              font-weight: 600;
              text-transform: none;
              letter-spacing: 0.5px;
              padding: 0 32px;
              height: 48px;
              font-size: 1rem;
              border-radius: 24px;
              transition: all 0.3s ease;
              font-family: "Roboto", sans-serif;

              &.back-btn {
                background: linear-gradient(135deg,
                    #1976d2 0%,
                    #1565c0 100%) !important;
                box-shadow: 0 4px 15px rgba(25, 118, 210, 0.3) !important;

                &:hover {
                  transform: translateY(-2px) !important;
                  box-shadow: 0 8px 25px rgba(25, 118, 210, 0.4) !important;
                }
              }

              &.close-btn {
                background: linear-gradient(135deg,
                    #6c757d 0%,
                    #495057 100%) !important;
                box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3) !important;
                color: white;

                &:hover {
                  transform: translateY(-2px) !important;
                  box-shadow: 0 8px 25px rgba(108, 117, 125, 0.4) !important;
                }
              }
            }
          }
        }
      }
    }
  }
}

// Responsive Design
@media (max-width: 900px) {
  .professional-lom-details {
    .lom-details-card {
      margin: 1rem;
      max-width: calc(100vw - 2rem);

      .professional-header {
        .header-content {
          padding: 1.5rem;

          .header-left {
            .icon-section {
              width: 48px;
              height: 48px;
              margin-right: 1rem;
            }

            .title-section {
              .modal-title {
                font-size: 1.5rem;
              }

              .modal-subtitle {
                font-size: 0.9rem;
              }
            }
          }
        }
      }

      .professional-content {
        .content-container {
          .main-content-section {
            padding: 1rem;

            .content-grid {
              grid-template-columns: 1fr;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 600px) {
  .professional-lom-details {
    .lom-details-card {
      margin: 0.5rem;
      max-width: calc(100vw - 1rem);

      .professional-header {
        .header-content {
          padding: 1rem;

          .header-left {
            .icon-section {
              width: 40px;
              height: 40px;
              margin-right: 0.75rem;
            }

            .title-section {
              .modal-title {
                font-size: 1.25rem;
              }

              .modal-subtitle {
                font-size: 0.85rem;
              }
            }
          }
        }
      }
    }
  }
}
</style>